module.exports = __webpack_public_path__ + "assets/assets/images/icons/icon-video-accent.368a713e.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/icon-video-accent.svg
// module id = 341
// module chunks = 2